import React from 'react';
import { howSteps } from '../data/content';
import { Eyebrow, Mark, SectionTitle } from './ui/Section';
export function HowItWorks() {
  return <section className="bg-canvas px-4 py-12 md:py-16" data-id="element-104" data-mp="7u6lqrwqxqr1">
      <div className="mx-auto max-w-6xl" data-id="element-105" data-mp="3pz9t6ja6qeum">
        <Eyebrow data-id="element-106" data-mp="3q0b3gljdmxba">How it works</Eyebrow>
        <SectionTitle data-id="element-107" data-mp="3tztn7dzgp2cj">
          A clear structure <Mark data-id="element-108" data-mp="3u0llwxocvg71">for every session</Mark>
        </SectionTitle>

        <ol className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-109" data-mp="ljrw5dwhcxng">
          {howSteps.map(step => <li key={step.number} className="flex flex-col rounded-2xl border border-navy/10 bg-white p-5 shadow-sm" data-id="element-110" data-mp="qjmnfik63p91">
              <span className="font-display text-3xl font-black leading-none text-brand" data-id="element-111" data-mp="cr6rf1poorhm">{step.number}</span>
              <h3 className="mt-3 font-display text-sm font-black uppercase leading-tight text-navy md:text-base" data-id="element-112" data-mp="gs0fbv34m6ai">
                {step.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-steel" data-id="element-113" data-mp="19adzirvjhtr4">{step.text}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}